import React from 'react';
import Image from 'next/legacy/image';

import { Flexbox } from '../Flexbox';

import {
  LoaderWrapper,
  ImageWrapper,
  BlockLoaderWrapper
} from './FullPageLoader.styles';

import whiteLogo from '@/images/gl-logo-full-white.svg';
import blockLoader from '@/images/block-loader-hd.gif';

export function FullPageLoader({ children }: { children?: React.ReactNode }) {
  return (
    <LoaderWrapper>
      <Flexbox className="relative" flexDirection="column" alignItems="center">
        <ImageWrapper>
          <Image src={whiteLogo} alt="Greenlight logo" />
        </ImageWrapper>

        {children}

        <BlockLoaderWrapper>
          <img src={blockLoader.src} alt="Block loader gif" />
        </BlockLoaderWrapper>
      </Flexbox>
    </LoaderWrapper>
  );
}
